
import { v4 as uuidv4 } from "uuid";
import { supabase } from "@/lib/supabase";

export const uploaderUtils = {
  fileToBase64: (file: File): Promise<string | null> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => {
        console.error('Error converting file to base64:', error);
        reject(null);
      };
    });
  },

  uploadToSupabase: async (file: File, userId: string): Promise<string> => {
    const fileExt = file.name.split(".").pop();
    const fileName = `${uuidv4()}.${fileExt}`;
    const filePath = `${userId}/${fileName}`;

    const { error } = await supabase.storage
      .from("images")
      .upload(filePath, file);

    if (error) {
      throw error;
    }

    const { data } = supabase.storage
      .from("images")
      .getPublicUrl(filePath);

    return data.publicUrl;
  }
};
